module.exports = __webpack_public_path__ + "ece4717cba8c9199b009d503a0031e5f.svg";